<template>
    <div class="va-table-wrapper">
        <h2>Task Panel</h2>

        <div class="va-task-table-filter">
            <div class="va-filter-sub-wrapper">
                <el-input
                    v-model="searchForm.text"
                    class="va-search-field"
                    clearable
                    placeholder="Suchtext"
                    prefix-icon="el-icon-search"
                    size="medium"
                >
                </el-input>

                <el-select v-model="searchForm.isEmailMatched" clearable placeholder="Email Verlinkung" size="medium">
                    <el-option v-for="item in emailMatchedOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>

                <el-select v-model="searchForm.status" clearable placeholder="Status" size="medium">
                    <el-option v-for="item in selectOptionHelper.taskStatusOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>

                <el-select v-model="searchForm.notification_flag" clearable placeholder="Benachrichtigung" size="medium">
                    <el-option v-for="item in selectOptionHelper.notificationOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>

            <div class="va-filter-sub-wrapper">
                <el-date-picker
                    v-model="searchForm.createdFrom"
                    type="date"
                    placeholder="Erstellt von"
                    size="medium"
                    align="center"
                    format="dd.MM.yyyy"
                >
                </el-date-picker>

                <el-date-picker
                    v-model="searchForm.createdTo"
                    type="date"
                    placeholder="Erstellt bis"
                    size="medium"
                    align="center"
                    format="dd.MM.yyyy"
                >
                </el-date-picker>

                <el-date-picker
                    v-model="searchForm.deadlineFrom"
                    type="date"
                    placeholder="Geplant von"
                    size="medium"
                    align="center"
                    format="dd.MM.yyyy"
                >
                </el-date-picker>

                <el-date-picker
                    v-model="searchForm.deadlineTo"
                    type="date"
                    placeholder="Geplant bis"
                    size="medium"
                    align="center"
                    format="dd.MM.yyyy"
                >
                </el-date-picker>
            </div>
        </div>

        <el-table
            ref="taskTable"
            :data="tableData"
            :default-sort="searchForm.sortingParams"
            :row-key="tableData.id"
            class="va-module-table"
            height="550px"
            stripe
            style="width: 100%"
            @sort-change="setSortingParams"
        >
            <!--only dynamic with column-->
            <el-table-column :sort-orders="allowedSorting" label="ID" prop="id" sortable="custom" width="60px"> </el-table-column>

            <el-table-column :sort-orders="allowedSorting" label="Zugewiesene Email" prop="assignee" sortable="custom">
                <template slot-scope="scope">
                    <el-tag size="small" class="va-table-tags">
                        {{ scope.row.assignee }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column :sort-orders="allowedSorting" label="Ersteller" prop="creator" sortable="custom"> </el-table-column>

            <el-table-column :sort-orders="allowedSorting" label="Titel" prop="title" sortable="custom"> </el-table-column>

            <el-table-column :sort-orders="allowedSorting" label="Status" prop="status" width="120px" sortable="custom">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status === 'open' ? 'danger' : scope.row.status === 'done' ? 'success' : 'warning'" size="small">
                        {{ selectOptionHelper.taskStatusTypeConverter(scope.row.status) }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column :sort-orders="allowedSorting" label="Erstellt am" prop="created_at" width="140px" sortable="custom">
                <template slot-scope="scope">
                    {{ datePickerHelper.formatUTCDateCH(scope.row.created_at) }}
                </template>
            </el-table-column>

            <el-table-column :sort-orders="allowedSorting" label="Geplant am" prop="deadline" sortable="custom" width="140px">
                <template slot-scope="scope">
                    {{ scope.row.deadline ? datePickerHelper.formatUTCDateCH(scope.row.deadline) : '-' }}
                </template>
            </el-table-column>

            <el-table-column :sort-orders="allowedSorting" label="Email verlinkt" prop="matched_email" sortable="custom" width="140px">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.matched_email ? 'success' : 'danger'" style="font-size: 17px">
                        <i :class="scope.row.matched_email ? 'el-icon-check' : 'el-icon-minus'"></i>
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column :sort-orders="allowedSorting" label="Notified" prop="notification_flag" sortable="custom" width="140px">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.notification_flag ? 'success' : 'danger'" style="font-size: 17px">
                        <i :class="scope.row.notification_flag ? 'el-icon-check' : 'el-icon-minus'"></i>
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column :sort-orders="allowedSorting" label="Aktionen" :sortable="false" width="80px">
                <template slot-scope="scope">
                    <el-button size="small" type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.row)"> </el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="va-table-footer">Zeige {{ tableData.length }} von {{ totalCount }} Einträgen</div>

        <el-pagination
            background
            :current-page="currentPage"
            :page-size="perPage"
            :page-sizes="[10, 20, 50, 100]"
            :total="totalCount"
            layout="sizes, prev, pager, next, jumper"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
        >
        </el-pagination>

        <el-dialog :visible.sync="deleteDialogVisible" center title="Warning" width="350px" custom-class="dialog">
            <div v-if="this.rowToDelete" class="va-delete-dialog-body">
                Den Task mit <b>ID {{ this.rowToDelete.id }}</b> wirklich löschen?
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDialogVisible = false">Abbrechen</el-button>
                <el-button type="danger" @click="deleteTask()">Löschen</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import auth from '../../auth.js'
import Vue from '../../main'
import selectOptionHelper from '../../Helpers/SelectOptionHelper.js'
import notification from '../../Helpers/NotificationHelper'
import datePickerHelper from '../../Helpers/DatePickerHelper'

export default {
    data() {
        return {
            auth: auth,
            selectOptionHelper: selectOptionHelper,
            datePickerHelper: datePickerHelper,

            submitDelay: 400, //ms
            submitTimer: null,

            currentPage: 1,
            perPage: 10,
            tableData: [],
            totalCount: 0, //for display of total count
            allowedSorting: ['ascending', 'descending'],

            searchForm: {
                text: '',
                status: '',
                notification_flag: undefined,
                isEmailMatched: '',
                deadlineFrom: '',
                deadlineTo: '',
                createdFrom: '',
                createdTo: '',

                sortingParams: {
                    prop: 'id',
                    order: 'ascending'
                }
            },

            emailMatchedOptions: [
                {
                    value: 'true',
                    label: 'Email verlinkt'
                },
                {
                    value: 'false',
                    label: 'Email nicht verlinkt'
                }
            ],

            rowToDelete: null,
            deleteDialogVisible: false
        }
    },

    methods: {
        handleDelete(row) {
            // open delete dialog
            this.deleteDialogVisible = true
            this.rowToDelete = row
        },

        deleteTask() {
            let row = this.rowToDelete
            if (row) {
                Vue.http
                    .post(
                        // Update or create? decide based on id field
                        'api/v1/task/delete',
                        {
                            id: row.id
                        }
                    )
                    .then(
                        () => {
                            // Remove deleted row from tableDate without reloading
                            let index = this.tableData.indexOf(row)
                            this.tableData.splice(index, 1)

                            // Reduce totalCount in table footer by one
                            this.totalCount -= 1

                            // Show success notification + close dialog
                            notification.showSuccess(this, 'Task wurden gelöscht')
                            this.deleteDialogVisible = false
                        },
                        () => {
                            notification.showError(this, 'Task konnte nicht gelöscht werden')
                            this.deleteDialogVisible = false
                        }
                    )
            }
        },

        setSortingParams(column, prop, order) {
            this.searchForm.sortingParams.prop = column.prop
            this.searchForm.sortingParams.order = column.order
        },

        returnDateOrNull(date) {
            return date ? this.datePickerHelper.formatUTCDateUS(date) : null
        },

        getAllTasks() {
            Vue.http
                .get('api/v1/task/get-all', {
                    params: {
                        text: this.searchForm.text,
                        status: this.searchForm.status,
                        isEmailMatched: this.searchForm.isEmailMatched,
                        notification_flag: this.searchForm.notification_flag,
                        deadlineFrom: this.returnDateOrNull(this.searchForm.deadlineFrom),
                        deadlineTo: this.returnDateOrNull(this.searchForm.deadlineTo),
                        createdFrom: this.returnDateOrNull(this.searchForm.createdFrom),
                        createdTo: this.returnDateOrNull(this.searchForm.createdTo),
                        column: this.searchForm.sortingParams.prop,
                        order: this.searchForm.sortingParams.order === 'ascending' ? 'asc' : 'desc',
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                })
                .then((response) => {
                    // Set entries counter and current page data
                    this.totalCount = response.data.totalCount
                    this.tableData = response.data.items || []
                })
        },

        handleCurrentChange(page) {
            this.currentPage = page
            this.getAllTasks()
        },

        handleSizeChange(size) {
            this.perPage = size
            this.resetTableLoader()
            this.getAllTasks()
        },

        resetTableLoader() {
            this.currentPage = 1 //reset page on filter change
            this.tableData = [] //reset tableData as well
        },

        sendDelayedSearchRequest() {
            //if timer exists: clear
            if (this.submitTimer) {
                clearTimeout(this.submitTimer)
                this.submitTimer = null
            }
            this.submitTimer = setTimeout(() => {
                this.getAllTasks()
            }, this.submitDelay)
        }
    },

    watch: {
        searchForm: {
            handler() {
                this.resetTableLoader() // Reset values on each form filter change
                this.sendDelayedSearchRequest()
            },
            deep: true
        }
    },

    beforeMount() {
        // Get all users in selected service
        this.getAllTasks()
    }
}
</script>
